import { InvoiceTypeConstants } from "./InvoiceType";

export class ProfileCreateModel {
    public subject: string; // *
    public firstName: string;
    public middleName: string; // *
    public lastName: string; // *
    // #165: the salutation — „Herr", „Frau", „Firma". The postal address is street/zip/city
    // below. Named `address` across the stack until this issue.
    public salutation: string; // *
    public companyName: string; // *
    public title: string; // *
    public street: string; // *
    public city: string; // *
    public zip: string; // *
    public countryId: string; // *
    // Backend #670: the customer's business contact address — shown to buyers on the
    // seller page, printed on invoices, and where seller order notices go. Prefilled from
    // the login address and editable; left empty, the backend falls back to the login.
    public email: string;
    public status: string; // *
    public role: string; // *
    public acceptedTac: string; // *
    public isRetailer: boolean = false;
    public smallBusinessP19UStG: boolean = false;
    public invoiceType: number = InvoiceTypeConstants.gross
}